<template>
  <div>
    <header class="facilitiesheader">
      <h1>Facility</h1>
      <h2>休閒設施</h2>
      <div class="line"></div>
    </header>
    <div class="facility-container">
      <div
        class="facility-item"
        v-for="facility in facilities"
        :key="facility.id"
        :class="{ 'reverse-layout': facility.id === 2 }"
      >
        <div class="facility-description">
          <div class="line-above"></div>
          <!-- 上方水平線 -->

          <h3>{{ facility.title }}</h3>
          <p>{{ facility.description }}</p>
          <strong>{{ facility.note }}</strong>
          <p><strong>營業時間：</strong>{{ facility.hours }}</p>
          <div class="line-below"></div>
          <!-- 下方水平線 -->
        </div>
        <div class="facility-image">
          <img :src="facility.image" alt="Facility Image" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LeisureFacilities",
  data() {
    return {
      facilities: [
        {
          id: 1,
          title: "活水游泳池 Lohas Area",
          description:
            "遠離喧擾世界，輕鬆臥躺遨遊。" +
            "數一數二的寬敞活水區及含三線道長20米深1.1米的露天游泳池，" +
            "水療SPA區維持在31°C-33°C，現場並提供浴巾、免費置物櫃，" +
            "男女更衣室內提供盥洗用品及脫水機。使用活水區需著泳衣、泳褲並戴泳帽，" +
            "具備合格救生員、AED急救設備。",
          note: "* 注意：未滿12歲需家長陪同",
          hours: "07:00-22:00",
          image: require("@/assets/picture/pool.32.jpg"), // 使用 require 引入圖片
        },
        {
          id: 2,
          title: "森活健身房 Gym",
          description:
            "遇健山林美好，房客專屬有氧活動" +
            "視野良好的多角度全景落地窗。健身設備有跑步機、" +
            "滑步機、划船機、登階機、背部伸展機、腹部訓練機、啞鈴等12項健身器材" +
            "男女更衣室內提供盥洗用品及脫水機。使用活水區需著泳衣、泳褲並戴泳帽，" +
            "住宿期間皆可免費使用，不開放外客。",
          note: "* 需滿16歲以上並穿著運動服及運動鞋。",
          hours: "07:00-22:00",
          image: require("@/assets/picture/gym.82.jpg"), // 使用 require 引入圖片
        },
        {
          id: 3,
          title: "藏書閣 Library",
          description:
            "閱讀是一種旅行，旅行不也是一種悅讀?" +
            "沉浸在二手書的世界裡，也能了解一個城市的文化" +
            "三面高達四個樓層高的書牆，穿透天窗，一方天色；這裡也是一個光影" +
            "幻化的小世界在光影中，穿越光陰，讀見海明威，翻過挪威森林..." +
            "光陰部落藏書閣共22層書架，蒐羅世界各地的二手書籍多達六千冊，" +
            "供客人免費借閱，將旅遊的感動延續，讓賓客24小時沉浸在文化的日光浴當中。",
          hours: "24小時開放使用",
          image: require("@/assets/picture/book.7.jpg"), // 使用 require 引入圖片
        },
      ],
    };
  },
};
</script>

<style src="@/assets/css/leisure.css" scoped></style>